module.exports = __webpack_public_path__ + "static/media/STANDARD.99d1a286.svg";